module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/SeasonalMobile-e0ab82ca08a73546b897822949056750.png";